import * as IoIcons from 'react-icons/io'
import { SideBarIcons } from './style'
import * as MdIcons from 'react-icons/md'
import {RiAppsLine, RiUserSearchLine} from 'react-icons/ri'
import {BsPeople, BsChatDots, BsChatRightText} from 'react-icons/bs'
import { BiTransfer } from 'react-icons/bi'
import { GiTakeMyMoney } from 'react-icons/gi'
import { AiOutlineMoneyCollect } from 'react-icons/ai'
import { MdNearbyError } from "react-icons/md";

export const sideBarData = [
    {
        title: 'Overview',
        path: '/customer-support/overview',
        icon: <SideBarIcons><RiAppsLine/></SideBarIcons>
    },
    {
        title: 'Customers',
        path: '',
        icon: <SideBarIcons size='1.9'><BsPeople/></SideBarIcons>,
        iconClosed: <IoIcons.IoIosArrowDown/>,
        iconOpened: <IoIcons.IoIosArrowUp/>,
        subNav: [
            {
                title: 'Find Customer',
                path: '/customer-support/customer-search',
                icon: <SideBarIcons size='1.8'><RiUserSearchLine/></SideBarIcons>
            },
            {
                title: 'All Customers',
                path: '/customer-support/all-customers',
                icon: <SideBarIcons size='1.8'><RiUserSearchLine/></SideBarIcons>
            },
        ]
    },
    {
        title: 'Portfolios',
        path: '/customer-support/all-portfolios',
        icon: <SideBarIcons size='1.8'><GiTakeMyMoney/></SideBarIcons>
    },
    {
        title: 'Loans',
        path: '/customer-support/all-loans',
        icon: <SideBarIcons size='1.8'><AiOutlineMoneyCollect/></SideBarIcons>
    },
    {
        title: 'Transactions',
        path: '/customer-support/all-transactions',
        icon: <SideBarIcons size='1.8'><BiTransfer/></SideBarIcons>
    },
    {
        title: 'Dispute & request',
        path: '/customer-support/dispute_request',
        icon: <SideBarIcons size='1.8'><BsChatDots/></SideBarIcons>
    },
    {
        title: 'Team Audit',
        path: '/customer-support/team-audit',
        icon: <SideBarIcons size='1.8'><RiUserSearchLine/></SideBarIcons>
    },
    {
        title: 'Error Logs',
        path: '/customer-support/error-logs',
        icon: <SideBarIcons size='1.8'><MdNearbyError /></SideBarIcons>
    },
    // {
    //     title: 'Disput Log',
    //     path: '/customer-support/dispute-log',
    //     icon: <SideBarIcons size='1.6'><BsChatRightText/></SideBarIcons>
    // }
]